import React from 'react';
import { useDispatch } from 'react-redux';
import { IconButton } from '@mui/material';

import { Icon, useSettings } from 'app/main/components';
import { type ViewListProps } from 'app/main/components/page-layouts/view/list/ViewList';
import { DetailsSectionWrapper, ViewList } from 'app/main/components/page-layouts';
import { showFastAddDialog } from 'app/main/modules/components/FastAddDialog';

interface ContactsTableProps {
	contactModule: string;
	parentModule: string;
	parentUid: string;
	itemLayout: ViewListProps['itemLayout'];
}

export default function ContactsTable({ contactModule, parentModule, parentUid, itemLayout }: ContactsTableProps) {
	const dispatch = useDispatch();
	const { settings, t } = useSettings(contactModule);

	const [refresh, setRefresh] = React.useState(false);
	const updateRefresh = () => setRefresh(state => !state);

	return (
		<DetailsSectionWrapper
			avatar={<Icon icon={settings.modu_icon} />}
			title={t(`MODULE_${contactModule}_NAME`)}
			subheader={t(`DETAILS_${contactModule}_SUBHEADER`)}
			headerAction={
				<IconButton
					onClick={() =>
						dispatch(
							showFastAddDialog({
								module: contactModule,
								model: {
									[`${settings.modu_short}_table`]: parentModule,
									[`${settings.modu_short}_table_uid`]: parentUid
								},
								updateRefresh,
								maxDialogWidth: 'sm',
								additionalProps: { disableIdentityAssociation: true }
							})
						)
					}
				>
					<Icon icon="plus-circle" />
				</IconButton>
			}
			disablePadding
		>
			<ViewList
				module={contactModule}
				itemLayout={itemLayout}
				refresh={refresh}
				updateRefresh={updateRefresh}
				defaultFilters={[
					{
						filt_field: `${settings.modu_short}_deleted`,
						filt_clause: 'not_equal',
						filt_value: 1
					},
					{
						filt_field: `${settings.modu_short}_table`,
						filt_clause: 'equals',
						filt_value: parentModule
					},
					{
						filt_field: `${settings.modu_short}_table_uid`,
						filt_clause: 'equals',
						filt_value: parentUid
					}
				]}
				showFilters={false}
				showExportButton={false}
				showBottomPagination={false}
			/>
		</DetailsSectionWrapper>
	);
}
